import { createBrowserRouter } from 'react-router'
import { HelloPage } from '@/pages/HelloPage'

export const router = createBrowserRouter([
  { path: '/', Component: HelloPage },
])
